<script>
  // A job uploaded but not yet queued.
  import { createEventDispatcher } from "svelte";
  import JobCard from "../UI/JobCard.svelte";
  import IconButton from "../UI/IconButton.svelte";
  import { download, deleteJob, queueJob } from "../../lib/jobs.js";
  import { formatDateTime } from "../../lib/format.js";

  export let fileId;
  export let filename;
  export let uploadedDateTime;

  const dispatch = createEventDispatcher();

  // "changed" asks the list to refetch. It replaces window.location.reload(),
  // which threw away the scroll position on every delete.
  async function remove() {
    if (await deleteJob(fileId, filename)) dispatch("changed");
  }

  $: meta = [{ label: "Uploaded", value: formatDateTime(uploadedDateTime) }];
</script>

<JobCard id={fileId} title={filename} status="ready" {meta}>
  <svelte:fragment slot="actions">
    <IconButton
      tip="Send to solver queue"
      icon="fa-paper-plane"
      colour="primary"
      onClick={() => queueJob(fileId)}
    />
    <IconButton
      tip="Download input python file"
      icon="fa-code"
      colour="warning"
      onClick={() => download.python(fileId)}
    />
    <IconButton
      tip="Download input excel file"
      icon="fa-file-excel"
      colour="success"
      onClick={() => download.inputExcel(fileId)}
    />
    <IconButton
      tip="Delete file"
      icon="fa-trash"
      colour="error"
      onClick={remove}
    />
  </svelte:fragment>
</JobCard>
